import { Link } from "react-router-dom";
import { ArrowUpRight, Clock, Sparkles } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { RECIPES } from "@/data/recipes";

const weekOfYear = () => {
  const now = new Date();
  const start = new Date(now.getFullYear(), 0, 1);
  return Math.floor((now - start) / 604800000);
};

export const RecipeSpotlight = () => {
  const recipe = RECIPES[weekOfYear() % RECIPES.length];
  return (
    <section className="py-16 md:py-24 bg-turmeric-light/50 border-y border-[#E7E2D7] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <Reveal className="lg:col-span-5 relative">
          <div className="absolute -inset-3 bg-beet/10 rounded-full rotate-3" aria-hidden="true" />
          <div className="relative overflow-hidden rounded-full aspect-square shadow-2xl border-8 border-paper-card">
            <img loading="lazy" decoding="async"
              src={recipe.image}
              alt={recipe.imageAlt}
              className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
            />
          </div>
          <span className="absolute -top-2 -right-2 md:right-6 bg-beet text-turmeric rounded-full px-4 py-2 font-mono text-[11px] tracking-[0.15em] uppercase font-semibold shadow-lg rotate-3">
            This Week
          </span>
        </Reveal>
        <div className="lg:col-span-7 lg:pl-6">
          <Reveal>
            <p className="font-mono text-xs tracking-[0.25em] uppercase text-clay font-semibold mb-4 flex items-center gap-2">
              <Sparkles size={14} /> Recipe of the Week
            </p>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight text-ink font-semibold leading-tight mb-5">
              {recipe.title}
            </h2>
            <p className="text-base md:text-lg leading-relaxed text-ink-soft max-w-xl mb-6">
              {recipe.excerpt}
            </p>
            <div className="flex flex-wrap items-center gap-4 mb-8">
              <span className="inline-flex items-center gap-1.5 bg-paper-card border border-[#E7E2D7] rounded-full px-4 py-2 font-mono text-[11px] tracking-[0.12em] uppercase font-semibold text-leaf">
                {recipe.tag}
              </span>
              <span className="inline-flex items-center gap-1.5 bg-paper-card border border-[#E7E2D7] rounded-full px-4 py-2 font-mono text-[11px] text-ink-muted">
                <Clock size={12} /> {recipe.time}
              </span>
            </div>
            <Link
              to="/recipes"
              data-testid="recipe-spotlight-link"
              className="editorial-link inline-flex items-center gap-2 text-sm font-semibold text-beet"
            >
              Cook it this week <ArrowUpRight size={16} />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
